function initBeginVideoTestimonials() {
  const section = document.querySelector(".begin-video-testimonials");
  if (!section) return;

  const modal = section.querySelector(".begin-video-testimonials__modal");
  const modalVideo = modal ? modal.querySelector(".begin-video-testimonials__modal-video") : null;
  const modalClose = modal ? modal.querySelector(".begin-video-testimonials__modal-close") : null;
  let lastTrigger = null;

  const closeModal = () => {
    if (!modal || !modalVideo) return;
    modalVideo.pause();
    modal.hidden = true;
    document.body.classList.remove("begin-video-testimonials__modal-open");
    if (lastTrigger) lastTrigger.focus();
  };

  const openModal = (sourceVideo, trigger) => {
    if (!modal || !modalVideo) return;
    modalVideo.innerHTML = sourceVideo.innerHTML;
    modalVideo.load();
    modalVideo.currentTime = sourceVideo.currentTime;
    lastTrigger = trigger;
    modal.hidden = false;
    document.body.classList.add("begin-video-testimonials__modal-open");
    modalVideo.play();
    if (modalClose) modalClose.focus();
  };

  if (modalClose) modalClose.addEventListener("click", closeModal);
  if (modal) {
    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeModal();
    });
  }
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal && !modal.hidden) closeModal();
  });

  const swiperEl = section.querySelector(".begin-video-testimonials__swiper");
  const navPrev = section.querySelector(".begin-video-testimonials__nav--prev");
  const navNext = section.querySelector(".begin-video-testimonials__nav--next");
  if (swiperEl) {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      allowTouchMove: true,
      navigation: {
        nextEl: navNext,
        prevEl: navPrev,
      },
      on: {
        slideChangeTransitionStart(swiper) {
          swiper.slides.forEach((slide, index) => {
            if (index === swiper.activeIndex) return;
            const video = slide.querySelector(".begin-video-testimonials__video");
            if (video) video.pause();
          });
        },
      },
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 24,
          allowTouchMove: false,
        },
      },
    });
  }

  const videos = Array.from(section.querySelectorAll(".begin-video-testimonials__video"));

  section.querySelectorAll(".begin-video-testimonials__card").forEach((card) => {
    const video = card.querySelector(".begin-video-testimonials__video");
    const playButton = card.querySelector(".begin-video-testimonials__play");
    const fullscreenButton = card.querySelector(".begin-video-testimonials__fullscreen");

    if (!video || !playButton) return;

    const label = video.getAttribute("aria-label");

    const setPlayingState = (isPlaying) => {
      card.classList.toggle("begin-video-testimonials__card--playing", isPlaying);
      playButton.setAttribute(
        "aria-label",
        isPlaying
          ? (label ? `Pause ${label} video` : "Pause video")
          : (label ? `Play ${label} video` : "Play video")
      );
    };

    playButton.addEventListener("click", () => {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener("play", () => {
      videos.forEach((other) => {
        if (other !== video && !other.paused) other.pause();
      });
      setPlayingState(true);
    });
    video.addEventListener("pause", () => setPlayingState(false));
    video.addEventListener("ended", () => setPlayingState(false));

    if (fullscreenButton) {
      fullscreenButton.addEventListener("click", () => {
        video.pause();
        openModal(video, fullscreenButton);
      });
    }
  });
}

document.readyState !== "loading"
  ? initBeginVideoTestimonials()
  : document.addEventListener("DOMContentLoaded", initBeginVideoTestimonials);
